import React from "react";
import PageHeader from "../components/PageHeader";
import { sansthanImg } from "../assets/assets.js";
import "../css/commontemplate.css";

export const VarshikUtsav = () => {
  return (
    <>
      <PageHeader
        title=" वार्षिक उत्सव "
        path="/about-goshala"
        name=" goshala"
      />
      <div className="comman-template-section">
        <div className="comman-template-container">
          {/* container  */}
          <div className="comman-template-sub-section">
            {/* sub-section */}
            <div className="comman-template-img-container">
              <img
                className="comman-template-image"
                src={sansthanImg.s_img04}
                alt=""
              />
            </div>
            <div className="comman-template-info-container">
              <h3>वार्षिक उत्सव </h3>
              <p>
                &nbsp;&nbsp;&nbsp;&nbsp; श्रींचा पुण्यतिथी उत्सव-प्रतिवर्षी चैत्रशुद्ध चतुर्दशी व अमावस्या या दरम्यान श्रींच्या पुण्यतिथी उत्सवाचे आयोजन होत असते. यामध्ये प्रामुख्याने चतुर्दशीच्या दिवशी श्रींच्या पुण्यतिथी पर कार्यक्रम  सायंकाळी धुपारती मंत्रजागर व सांस्कृतिक कार्यक्रमांचे आयोजन तसेच दुसरे दिवशी अमावस्येला श्रींची सामूहिक महाभिषेक पूजा व सायंकाळी श्रींची पालखी मिरवणूक ग्रामपरिक्रमेसाठी निघते. या कार्यक्रमासाठी प्रतिवर्षी हजारोंच्या संख्येने भक्तगण उपस्थित असतात.
              </p>
            </div>
          </div>
          {/* second one  */}

          <div className="comman-template-sub-section"></div>
        </div>
      </div>
    </>
  );
};
